import React, { useEffect } from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import InfoCard from '../../components/InfoCard'; 
import Styles from "./styles.module.scss";
import ActivePositionsTable from './activePositionsTable';
import ChartGraph from '../../components/chart';


function PositionStatus(props: any) {
    

  const series = [
    {
      name: "My Active Positions",
      data: [parseInt(props && props.chartData && props.chartData.myActiveCount)],
    },
    {
      name: "Submitted To Hirer",
      data: [parseInt(props && props.chartData && props.chartData.submittedToHirerCount)],
    },
    {
      name: "Offer Accepted",
      data: [parseInt(props && props.chartData && props.chartData.offerAcceptedCount)],
    }
  ];

  const selectColor = (data: any) => {
    
    switch (data) {
      case 'My Active Positions':
        return '#FFC633'
      case 'Submitted To Hirer':
        return '#344F97'
      case 'Offer Accepted':
        return '#14A800'
    }
    
  }

  return (
    <section className="infoCardGrid">
        <InfoCard title="">
         <ActivePositionsTable data={props.tableData} />
        </InfoCard>
        {/* <InfoCard title="Active Positions">
        <ChartGraph data={series} selectColour={selectColor} />
        </InfoCard> */}
    </section>
  )
}

export default PositionStatus